import { createAsyncThunk } from '@reduxjs/toolkit';
import { $api } from '../../../shared/api';
import { TTaskStatus } from '../model/types/tasks';

interface FetchTasksError {
    message: string;
}

interface TaskPayload {
    taskId: string;
    entityUid: string;
    switcherStatus: TTaskStatus;
}

export const changeCustomTaskStatus = createAsyncThunk<
    any,
    TaskPayload,
    { rejectValue: FetchTasksError }
>('tasks/changeCustomTaskStatus', async (taskPayload, thunkApi) => {
    const { taskId, entityUid, switcherStatus } = taskPayload;
    //@ts-ignore
    const url = routable.getRoute('switchCustomTaskStatus');
    const formattedUrl = url.replace('_customTask_', entityUid);

    const formData = new FormData();
    formData.append('status', switcherStatus);

    try {
        const response = await $api.post<any>(`${formattedUrl}`, formData);
        // console.log('changeCustomTaskStatus response: ', response);
        return { taskId, switcherStatus, newTabs: response.data.data.new_tabs };
    } catch (error) {
        // console.log('error ', error.response.data);
        return thunkApi.rejectWithValue(
            error.response?.data || {
                message: i18next.t('Errors.UnknownError.text'),
            }
        );
    }
});
